// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__2e0LR","tabItem":"Content_tabItem__ellhk","row":"Content_row__82_kJ","image":"Content_image__1lsuc"};